import styled from 'styled-components';

import Input from 'hive-admin/src/components/Input/Input';

import { renderCurrency } from '../../components/SystemCountry';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createChangeLogSection } from '../../components/FieldChangeLog';

const conditionAmountFullTrue = [
  'condition.testFieldValue',
  'amountFull',
  '===',
  true,
];

const InputUppercase = styled(Input)`
  text-transform: uppercase;
`;

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
}];

export const fieldCode = ['FieldText', {
  name: 'code',
  Component: InputUppercase,
  rules: [['validation.isRequired']],
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the discount code store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [props => props.activity !== 'create'],
  virtual: [props => props.activity !== 'create'],
}];

export const fieldUsageMax = ['FieldText', {
  name: 'usageMax',
  label: 'Number of times code can be used',
  type: 'number',
  initialValue: 0,
  placeholder: 0,
  description: '*set to 0 for unlimited usage',
}];

export const fieldAmountDivider = ['Divider', {
  name: 'amountDivider',
}];

export const fieldAmountFull = ['FieldSwitch', {
  name: 'amountFull',
  label: null,
  inlineLabelBefore: 'Make all items free',
  initialValue: false,
}];

export const fieldAmountShippingAndPaymentFull = ['FieldSwitch', {
  name: 'amountShippingAndPaymentFull',
  label: null,
  inlineLabelBefore: 'Make delivery free',
  initialValue: false,
}];

export const fieldAmountFixed = ['FieldText', {
  name: 'amountFixed',
  label: 'Items Fixed Amount',
  initialValue: 0,
  type: 'number',
  align: 'right',
  addonAfter: renderCurrency(),
  skip: [conditionAmountFullTrue],
}];

export const fieldAmountPercentage = ['FieldText', {
  name: 'amountPercentage',
  label: 'Items Percentage Amount',
  initialValue: 0,
  type: 'number',
  align: 'right',
  addonAfter: '%',
  skip: [conditionAmountFullTrue],
}];

export const ADMIN = [
  fieldName,
  fieldCode,
  fieldStore,
  fieldUsageMax,
  fieldAmountDivider,
  getFilterWithCol(fieldAmountFull, 12),
  getFilterWithCol(fieldAmountShippingAndPaymentFull, 12),
  getFilterWithCol(fieldAmountFixed, 12),
  getFilterWithCol(fieldAmountPercentage, 12),
  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'DiscountCode',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const SELLER = [
  fieldName,
  fieldCode,
  fieldUsageMax,
  fieldAmountDivider,
  getFilterWithCol(fieldAmountFull, 12),
  getFilterWithCol(fieldAmountShippingAndPaymentFull, 12),
  getFilterWithCol(fieldAmountFixed, 12),
  getFilterWithCol(fieldAmountPercentage, 12),
];
